__turbopack_context__.v({
  "buttonBox": "AddToWishlistButton-module__UXiC1a__buttonBox",
});
